export const formatFixMetric = (value, suffix = '') =>
  typeof value === 'number' && Number.isFinite(value) ? `${value.toLocaleString()}${suffix}` : 'Unavailable';
